// extracted by mini-css-extract-plugin
export default {"icon-button-wrapper":"_3Qz2a","iconButtonWrapper":"_3Qz2a","number":"_1mRSk"};